exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".socialLinks[data-v-b3baa8ce]{color:#fff!important;font-size:20px!important}.footer[data-v-b3baa8ce]{font-size:12px!important}.imagenFooterHotel[data-v-b3baa8ce]{width:100%}.footer-heading[data-v-b3baa8ce],.FooterTittle[data-v-b3baa8ce]{font-size:14px!important}@media only screen and (max-width:750px){.imagenFooterHotel[data-v-b3baa8ce]{width:60%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b3baa8ce","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/MyFooter.vue
// module id = 449
// module chunks = 2